<template>
  <div class="container justify-content-center mt-5">
    <div
      class="
        row
        d-flex
        justify-content-center
        company-product-payment-success-page
      "
    >
      <div class="col-md-8 mt-3">
        <h3 class="text-center mb-4 page-title">{{ $t(LangConstants.thanks_for_order_heading) }}</h3>
        <p class="mb-5 text-center page-desc">
          {{ $t(LangConstants.order_confirmation_mail_sent_text) }}
        </p>

        <div class="row form-base order-info-entitites pl-3 pr-3 mb-4">
          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.order_number_text) }}</span>
            <span class="value">{{ this.orderNumber }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.product_text) }}</span>
            <span class="value">{{ productName }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.total_cost_text) }}</span>
            <span class="value">{{ this.totalCost }}</span>
          </div>
        </div>

        <div class="row form-base pl-3 pr-3 mb-4 redirect-home">
          <div class="col-md-12 order-info-entity mb-4">
            <div class="row">
              <div class="col-auto">
                <i class="fa fa-building" aria-hidden="true"></i>
              </div>
              <div class="col text">
                {{ $t(LangConstants.customer_pages_heading) }}
                <div class="description">
                  {{ $t(LangConstants.customer_pages_text) }}
                </div>
              </div>
            </div>

            <!-- <div class="row mt-4">
              <div class="col-md-12">
                <my-button
                  fa="bars"
                  label="Open"
                  variant="solid-secondary"
                  classes="mr-1"
                  height="56px"
                  width="100%"
                ></my-button>
              </div>
            </div> -->
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-center">
            <div class="mb-2">
              <my-button fa="" :label="$t(LangConstants.contact_us_button_label)" variant="box-primary" classes="mr-1" height="64px" minwidth="400px" @onClick="onclick"></my-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Webshop Payment Success Page
 */
import "../../../../assets/scss/companyproductpaymentsuccesspage.scss";
import MyButton from "../../../../components/atoms/Button.vue";
import common from "../../../../functions/index";
import Csrf from "../../../../apis/Csrf";
import Constants from "../../../../constants/index";

const dayjs = require("dayjs");

export default {
  name: "webshop-payment-success",
  async created() {
    try {
      const self = this;
      let formData = common.getFromLocalStorage(this.$route.params.id);

      const trType = this.$route.params.type;
      this.subscriptionId = null;

      switch (trType) {
        case "subscription":
          {
            this.subscriptionId = this.$route.params.id;
          }
          break;
        case "card":
          {
            this.handleStripeCardPayment(self, formData, trType);
          }
          break;
        case "invoice_internal":
          {
            this.handleInvoiceInternalPayment(self, formData, trType);
          }
          break;
        case "woocommerce_integration":
          {
            this.handleWoocommercePayment(self, formData, trType);
          }
          break;
      }
    } catch (error) {
      this.$fire({
        title: this.$t(this.LangConstants.error_retrieving_subscription_heading),
        text: this.$t(this.LangConstants.stripe_api_error_text),
        type: "error",
        html: "",
      });
    }
  },

  methods: {
    onclick() {
      window.open("https://sparkfore.com/", "_blank").focus();
    },

    // async handleWoocommercePayment(self, formData, trType) {
    //   let quantity = (!formData.product.quantity )? 1 : formData.product.quantity;
    //   this.productName = formData.product.productName;
    //   this.orderNumber = formData.payment.preorderid;
    //   let amount = (formData.product.discount_amount ? formData.product.amount - formData.product.discount_amount : formData.product.amount) * quantity;
    //   this.totalCost = common.formatMoney(parseFloat(amount).toFixed(2), common.toUpperCase(formData.product.currency));

    //   let payload = {
    //     webshop_payment: {
    //       order_reference_id: this.orderNumber,
    //       instance_id: formData.user.instance_id,
    //       date_paid: Date.now(),
    //       status: formData.customer.is_trusted ? "success" : "pending",
    //       method: trType,
    //       return_log: JSON.stringify({}),

    //       event_id: formData.product.event_id,
    //       total: amount,
    //       sub_total: formData.product.amount * quantity,
    //       discount: formData.product.discount_amount,
    //       currency: formData.product.currency,
    //       quantity: formData.product.quantity,
    //       group_name: formData.group_name,
    //     },
    //     stripe_connect_account_id: null,
    //     webshop_id: formData.product.webshopId,
    //     charge_id: this.chargeId,
    //     payment_intent_response: JSON.stringify({}),
    //     participants: formData.participants,
    //   };

    //   formData.user.lms_url = window.location.origin;
    //   formData.user.phone_1 = formData.user.phone;

    //   // console.log(self);
    //   // console.log(formData);
    //   // console.log(trType);
    //   // console.log(payload);

    //   this.payment = await this.$store.dispatch("createWebshopPayment", JSON.stringify(payload));
    //   // this.paymentId = this.payment.data.webshop_payment.id;

    //   if (formData.user.userType == "new") {
    //     const userData = {
    //       user: {
    //         lms_url: window.location.origin,
    //         instance_id: formData.user.instance_id,
    //         first_name: formData.user.first_name,
    //         last_name: formData.user.last_name,
    //         email: formData.user.email,
    //         password: formData.user.password,
    //         phone_1: formData.user.phone,
    //         courseid: formData.user.courseid,
    //         eventid: formData.product.event_id,
    //         groupName: formData.group_name,
    //         participants: formData.participants,
    //       },
    //       method: trType,
    //     };

    //     // console.log(userData);

    //     let form = {
    //       token_retrieval_url: "/login/token.php?username=wsuser&password=wsUs3eR@s!te&service=sparkforeapi",
    //       update_url: "/webservice/restful/server.php/local_sparkfore_register_woocommerce_user",
    //       payload: JSON.stringify(userData),
    //     };

    //     this.$store.dispatch("registerWooUsers", form).then(async (result) => {
    //       // if (result.status == "success") {
    //       // if (result.userid) {
    //       self.moodleUserId = result.userid;
    //       self.lmsUrl = result.loginurl;
    //       Csrf.setCookie("MoodleSession", result.MoodleSession);

    //       // let updatePayload = {
    //       //   id: this.paymentId,
    //       //   webshop_payment: {
    //       //     userid: result.userid,
    //       //   },
    //       // };
    //       // this.updateWebShopPayment(updatePayload, formData, result.loginurl);
    //       // }
    //       // } else {
    //       //   this.$fire({
    //       //     title: result.message,
    //       //     type: "error",
    //       //     html: result.error,
    //       //   });
    //       // }
    //     });
    //   }
    // },

    async handleInvoiceInternalPayment(self, formData, trType) {
      let quantity = (!formData.product.quantity )? 1 : formData.product.quantity;
      this.productName = formData.product.productName;
      this.orderNumber = "ITNL-" + Date.now();
      let amount = (formData.product.discount_amount ? formData.product.amount - formData.product.discount_amount : formData.product.amount) * quantity;
      this.totalCost = common.formatMoney(parseFloat(amount).toFixed(2), common.toUpperCase(formData.product.currency));
      // console.log(self, formData, trType);

      let payload = {
        webshop_payment: {
          order_reference_id: this.orderNumber,
          instance_id: formData.user.instance_id,
          date_paid: Date.now(),
          status: formData.customer.invoiceallowed ? "success" : "pending",
          method: trType,
          return_log: JSON.stringify({}),

          event_id: formData.product.event_id,
          total: amount,
          sub_total: formData.product.amount * quantity,
          discount: formData.product.discount_amount,
          currency: formData.product.currency,
          quantity: formData.product.quantity,
          group_name :formData.group_name,
        },
        stripe_connect_account_id: null,
        webshop_id: formData.product.webshopId,
        charge_id: this.chargeId,
        payment_intent_response: JSON.stringify({}),
        participants: formData.participants,
      };

      formData.user.lms_url = window.location.origin;
      formData.user.phone_1 = formData.user.phone;

      this.payment = await this.$store.dispatch("createWebshopPayment", JSON.stringify(payload));

      this.paymentId = this.payment.data.webshop_payment.id;

      if (formData.user.userType == "new") {
        const userData = {
          user: {
            lms_url: window.location.origin,
            instance_id: formData.user.instance_id,
            first_name: formData.user.first_name,
            last_name: formData.user.last_name,
            email: formData.user.email,
            password: formData.user.password,
            phone_1: formData.user.phone,
            courseid: formData.user.courseid,
            course_type: formData.user.courseType, // new
            eventid: formData.product.event_id,
            groupName: formData.group_name,
            participants: formData.participants,
          },
          customer: formData.customer, // new
          group_name: formData.group_name, // new
          method: trType,
        };

        this.$store.dispatch("registerWebShopUser", userData).then(async (result) => {
          if (result.status == "success") {
            self.moodleUserId = result.userid;
            self.lmsUrl = result.loginurl;
            Csrf.setCookie("MoodleSession", result.MoodleSession);

            let updatePayload = {
              id: this.paymentId,
              webshop_payment: {
                userid: result.userid,
              },
            };
            this.updateWebShopPayment(updatePayload, formData, result.loginurl);
          } else {
            this.$fire({
              title: result.message,
              type: "error",
              html: result.error,
            });
          }
        });
      } else {
        const userFormData = {
          username: formData.user.email,
          password: formData.user.password,
        };

        this.$store
          .dispatch("loginWebShopUser", userFormData)
          .then((result) => {
            // console.log("login");
            // console.log(result);
            // common.deleteFromLocalStorage(this.$route.params.id)
            if (result.response == 2) {
              const userEnrolData = {
                userid: result.data.userid,
                courseid: formData.user.courseid,
                course_type: formData.user.courseType, // new
                eventid: formData.product.event_id,
                participants: formData.participants,
                group_name: formData.group_name, // new
                method: trType,
              };
              this.$store
                .dispatch("enrolExistingUser", userEnrolData)
                .then((result) => {
                  // console.log("enrol");
                  // console.log(result);
                  if (result.success == true) {
                    let updatePayload = {
                      id: this.paymentId,
                      webshop_payment: {
                        userid: result.data.userid,
                      },
                    };
                    this.updateWebShopPayment(updatePayload, formData, window.location.origin);
                  } else {
                    console.log("no user");
                  }
                })
                .catch((error) => {
                  this.$fire({
                    title: this.$t(this.LangConstants.error_text),
                    text: this.$t(this.LangConstants.common_error_title),
                    type: "error",
                    html: "<div>" + this.$t(error) + "</div>",
                  });
                });
            } else {
              console.log("no user");
            }
          })
          .catch((error) => {
            this.$fire({
              title: this.$t(this.LangConstants.error_text),
              text: this.$t(this.LangConstants.common_error_title),
              type: "error",
              html: "<div>" + this.$t(error) + "</div>",
            });
          });
      }

      await this.$store.dispatch("createWebshopPaymentInquiry", {
        to_address: formData.user.email, // training manager email address
        template_id: "27977494",
        template_parameters: {
          product_url: "https://sparkfore.com",
          product_name: formData.product.productName,
          name: formData.user.first_name + " " + formData.user.last_name,
          action_url: "",
          support_url: "https://sparkfore.com",
          company_name: formData.customer.organization_name,
          company_address: "",
          invoice_id: String(formData.product.webshopId).padStart(6, "0"),
          date: dayjs().format("DD-MM-YYYY"),
        },
      });
    },

    async handleStripeCardPayment(self, formData, trType) {
      let sessData = await this.$store.dispatch("getStripeCheckoutSession", { id: this.$route.params.id, connectedAccount: this.$route.params.connectedAccount });

      sessData = JSON.parse(JSON.stringify(sessData));
      let quantity = (!formData.product.quantity )? 1 : formData.product.quantity;
      // this.subdomain = sessData["metadata"]["subdomain"];
      this.productName = sessData["metadata"]["product"];
      this.paymentIntent = await this.$store.dispatch("getStripePaymentIntent", { id: sessData["payment_intent"], StripeAccount: this.$route.params.connectedAccount });
      let amount = this.paymentIntent.data.charges.data[0].amount / 100;
      this.totalCost = parseFloat(amount).toFixed(2) + " " + this.paymentIntent.data.charges.data[0].currency;
      this.chargeId = this.paymentIntent.data.charges.data[0].id;
      this.orderNumber = this.paymentIntent.data.id;

      let payload = {
        webshop_payment: {
          order_reference_id: this.orderNumber, //  this.paymentIntent.data.id;
          instance_id: formData.user.instance_id,
          date_paid: this.paymentIntent.data.charges.data[0].created,
          status: formData.customer.invoiceallowed ? "success" : "success",
          method: trType,
          return_log: JSON.stringify(this.paymentIntent),

          event_id: formData.product.event_id,
          total: amount,
          sub_total: formData.product.amount * quantity,
          discount: formData.product.discount_amount,
          currency: formData.product.currency,
          quantity: formData.product.quantity,
          group_name: formData.group_name,
        },
        stripe_connect_account_id: this.$route.params.connectedAccount,
        webshop_id: formData.product.webshopId,
        charge_id: this.chargeId,
        payment_intent_response: JSON.stringify(this.paymentIntent.data),
        participants: formData.participants,
      };

      this.payment = await this.$store.dispatch("createWebshopPayment", JSON.stringify(payload));
      this.paymentId = this.payment.data.webshop_payment.id;

      if (this.chargeId == null || !this.chargeId) {
        this.$fire({
          title: this.$t(this.LangConstants.error_retrieving_subscription_heading),
          text: this.$t(this.LangConstants.no_subscription_id_message),
          type: "error",
          html: "",
        });
      } else {
        if (formData.user.userType == "new") {
          // if new, Create moodle account and enrol in course
          const userData = {
            user: {
              lms_url: window.location.origin,
              instance_id: formData.user.instance_id,
              first_name: formData.user.first_name,
              last_name: formData.user.last_name,
              email: formData.user.email,
              password: formData.user.password,
              phone_1: formData.user.phone,
              courseid: formData.user.courseid,
              course_type: formData.user.courseType, // new
              eventid: formData.product.event_id,
              groupName: formData.group_name,
              participants: formData.participants,
            },
            customer: formData.customer, // new
            group_name: formData.group_name, // new
            method: trType,
          };

          this.$store.dispatch("registerWebShopUser", userData).then(async (result) => {
            if (result.status == "success") {
              // console.log(result);
              self.moodleUserId = result.userid;
              self.lmsUrl = result.loginurl;
              Csrf.setCookie("MoodleSession", result.MoodleSession);
              // let payload = {
              //     'webshop_payment':{
              //       'instance_id' : formData.user.instance_id,
              //       'user_id': result.userid,
              //       'date_paid': this.paymentIntent.data.charges.data[0].created,
              //       'status': 'success',
              //       'method': trType,
              //       'return_log': JSON.stringify(this.paymentIntent)
              //     },
              //     'stripe_connect_account_id': this.$route.params.connectedAccount,
              //     'webshop_id': formData.product.webshopId,
              //     'charge_id': this.chargeId,
              //     'payment_intent_response': JSON.stringify(this.paymentIntent.data)
              //   }
              let updatePayload = {
                id: this.paymentId,
                webshop_payment: {
                  userid: result.userid,
                },
              };
              this.updateWebShopPayment(updatePayload, formData, result.loginurl);
            } else {
              this.$fire({
                title: result.message,
                type: "error",
                html: result.error,
              });
            }
          });
        } else {
          const userFormData = {
            username: formData.user.email,
            password: formData.user.password,
          };

          this.$store
            .dispatch("loginWebShopUser", userFormData)
            .then((result) => {
              // common.deleteFromLocalStorage(this.$route.params.id)
              if (result.response == 2) {
                const userEnrolData = {
                  userid: result.data.userid,
                  courseid: formData.user.courseid,
                  course_type: formData.user.courseType, // new
                  eventid: formData.product.event_id,
                  participants: formData.participants,
                  group_name: formData.group_name, // new
                  method: trType,
                };
                this.$store
                  .dispatch("enrolExistingUser", userEnrolData)
                  .then((result) => {
                    // console.log(result);
                    if (result.success == true) {
                      // let payload = {
                      //   'webshop_payment': {
                      //     'instance_id' : formData.user.instance_id,
                      //     'user_id': result.data.userid,
                      //     'date_paid':  this.paymentIntent.data.charges.data[0].created,
                      //     'status': 'success',
                      //     'method': trType,
                      //     'return_log': JSON.stringify(this.paymentIntent)
                      //   },
                      //   'stripe_connect_account_id': this.$route.params.connectedAccount,
                      //   'webshop_id': formData.product.webshopId,
                      //   'charge_id': this.chargeId,
                      //   'payment_intent_response': JSON.stringify(this.paymentIntent.data)
                      // }
                      let updatePayload = {
                        id: this.paymentId,
                        webshop_payment: {
                          userid: result.data.userid,
                        },
                      };
                      this.updateWebShopPayment(updatePayload, formData, window.location.origin);
                    } else {
                      console.log("no user");
                    }
                  })
                  .catch((error) => {
                    this.$fire({
                      title: this.$t(this.LangConstants.error_text),
                      text: this.$t(this.LangConstants.common_error_title),
                      type: "error",
                      html: "<div>" + this.$t(error) + "</div>",
                    });
                  });
              } else {
                console.log("no user");
              }
            })
            .catch((error) => {
              this.$fire({
                title: this.$t(this.LangConstants.error_text),
                text: this.$t(this.LangConstants.common_error_title),
                type: "error",
                html: "<div>" + this.$t(error) + "</div>",
              });
            });
        }
      }
    },

    async updateWebShopPayment(payload, formData, lmsUrl) {
      try {
        let payment = await this.$store.dispatch("updateWebshopPayment", payload);
        if (payment) {
          await this.$fire({
            title: this.$t(this.LangConstants.registration_successful_with_redirection_text),
            type: "success",
            timer: 6000,
          });
          this.redirectUser(formData, lmsUrl);
        }
      } catch (error) {
        this.$fire({
          title: this.$t(this.LangConstants.subscription_status_error_heading),
          text: this.$t(this.LangConstants.create_webshop_payment_failed_text),
          type: "error",
          html: "<div>" + this.$t(error) + "</div>",
        });
      }
    },

    redirectUser(formData, lmsUrl) {
      /*
      if (formData.user.courseType == "instructor_led_training" && formData.user.userType == "old") {
        if (formData.user.is_teamlead) {
          this.$router.push({ name: "CompanyAccountSubscription" });
          // } else if (formData.participants.length == 1 && formData.participants[0].email == formData.user.email) {
          //   window.location.href = lmsUrl;
        } else if (formData.participants.length > 1) {
          const signInAsParticipant = formData.participants.find((participant) => participant.email == formData.user.email);
          if (signInAsParticipant) {
            window.location.href = lmsUrl;
          }
        }
      } else {
        if (formData.participants.length > 1) {
          const signInAsParticipant = formData.participants.find((participant) => participant.email == formData.user.email);
          if (signInAsParticipant) {
            window.location.href = lmsUrl;
          }
        }

        // window.location.href = lmsUrl;
      }*/
      window.location.href = lmsUrl;
    },
  },

  computed: {
    LangConstants() {
      return Constants;
    },
  },

  data() {
    return {
      productName: "",
      productInterval: "",
      orderNumber: "",
      // subdomain: null,
      totalCost: "",
      subscriptionId: null,
      moodleUserId: null,
      lmsUrl: null,
      chargeId: null,
      paymentIntent: null,
      payment: null,
      paymentId: null,
      userType: "",
      discount: 0,
      formData: {},
    };
  },
  components: {
    MyButton,
  },
};
</script>
